module.exports = __webpack_public_path__ + "media/images/logos/download-for-android-5e47af258a530e684448579ad3ea25b9.png";